import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import type { EmailAttachmentMetadata, Pageable, WrapperPageableResponse, WrapperResponse } from '../core/models';

/** `SUPPRESSED`: no se envió porque la compañía desactivó ese correo automático (modo headless). */
export type EmailAuditStatus = 'PENDING' | 'SENT' | 'FAILED' | 'SUPPRESSED';

export const SUPPRESSED_EMAIL_TOOLTIP = 'No se envió: la compañía tiene desactivado este correo automático';
export type EmailProvider = 'MAILGUN' | 'SMTP';

export interface EmailAuditDTO {
  id?: number;
  template?: string;
  /** Tipo de correo al cliente final (catálogo de notificaciones); vacío en correos internos. */
  customerNotificationType?: string | null;
  fromAddress?: string;
  replyTo?: string;
  toAddresses?: string;
  ccAddresses?: string;
  bccAddresses?: string;
  subject?: string;
  body?: string;
  domain?: string;
  provider?: EmailProvider;
  status?: EmailAuditStatus;
  errorMessage?: string;
  sentAt?: string;
  openedAt?: string;
  openCount?: number;
  createdAt?: string;
  updatedAt?: string;
  triggeredByUserId?: number;
  triggeredByUserName?: string;
  triggeredByUserEmail?: string;
  customerId?: number;
  customerName?: string;
  customerEmail?: string;
  saleId?: number;
  saleNumber?: string;
  subscriptionId?: number;
  subscriptionNumber?: string;
  saleLinkId?: number;
  saleLinkNumber?: string;
  attachments?: EmailAttachmentMetadata[];
}

export interface ListEmailAuditFilterSpec {
  customerId?: number;
  'customer[lk]'?: string;
  saleId?: number;
  subscriptionId?: number;
  saleLinkId?: number;
  template?: string;
  'template[lk]'?: string;
  status?: EmailAuditStatus;
  customerNotificationType?: string;
  provider?: EmailProvider;
  'from[lk]'?: string;
  'subject[lk]'?: string;
  'to[lk]'?: string;
  'createdAt[gte]'?: string;
  'createdAt[lte]'?: string;
}

export type WrapperPageableResponseEmailAuditDTO = WrapperPageableResponse<EmailAuditDTO>;
export type WrapperResponseEmailAuditDTO = WrapperResponse<EmailAuditDTO>;

@Injectable({ providedIn: 'root' })
export class EmailAuditService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  list(
    spec: ListEmailAuditFilterSpec = {},
    pageable: Pageable = { page: 0, size: 20, sort: ['createdAt,desc'] }
  ): Observable<WrapperPageableResponseEmailAuditDTO> {
    let params = new HttpParams();
    Object.entries(spec).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, String(value));
      }
    });
    params = params.append('page', String(pageable.page));
    params = params.append('size', String(pageable.size));
    pageable.sort?.forEach((sort) => {
      params = params.append('sort', sort);
    });
    return this.http.get<WrapperPageableResponseEmailAuditDTO>(`${this.apiUrl}/emails/audit/list`, { params });
  }

  getById(id: number): Observable<WrapperResponseEmailAuditDTO> {
    return this.http.get<WrapperResponseEmailAuditDTO>(`${this.apiUrl}/emails/audit/${id}`);
  }
}
